// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState, useRef } from 'react';
import { CSSProperties } from 'styled-components';
import TriangleIcon from '../../assets/option-triangle.svg';
import { FormattedMessage, useIntl } from 'react-intl';
import { S } from './styles';

interface Item {
  id: number | string;
  label: string;
  value: string | number;
}
interface Props {
  options: Item[];
  name: string;
  value: string | number;
  placeholder: string;
  error?: string;
  style?: CSSProperties;
  setFieldValue: (arg: string, arg1: string | number) => void;
}

const Dropdown = (props: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const [label, setLabel] = useState('');
  const wrapperRef = useRef<HTMLDivElement>(null);
  const placeHolderRef = useRef<HTMLSpanElement>(null);
  const intl = useIntl();
  useEffect(() => {
    props.options.map((option: any) => {
      if (option.value === props.value) {
        setLabel(option.label);
      }
      return null;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value, intl.messages]);

  const handleWindowClick = (event: any) => {
    const ref = wrapperRef.current;
    const placeRef = placeHolderRef.current;
    if (ref) {
      const children = Array.from(ref.children)
      if (ref !== event.target && !children.includes(event.target) && event.target !== placeRef) {
        hideDropdown();
        return
      }
    }
  };

  const showDropdown = () => {
    setIsOpen(!isOpen);
    window.addEventListener('click', handleWindowClick, false);
  };

  const hideDropdown = () => {
    setIsOpen(false);
    window.removeEventListener('click', handleWindowClick);
  };

  const chooseItem = (item: Item) => {
    props.setFieldValue(props.name, item.value);
    setLabel(item.label);
    hideDropdown();
  };

  const openCss = isOpen ? '#FFFFFF 0% 0% no-repeat padding-box' : '';
  const errorCss = props.error ? '0.75px solid red' : '';
  return (
    <S.SupportTypeOptionsWrapper
      onClick={showDropdown}
      ref={wrapperRef}
      {...props}
    >
      <S.OptionText
        style={{ background: openCss, border: errorCss }}
      >
        {label ? label : <S.PlaceHolder ref={placeHolderRef}> {props.placeholder} </S.PlaceHolder>}
      </S.OptionText>
      <S.OptionTriangle
        src={TriangleIcon}
      />
      <S.Menu
        style={isOpen ? { display: 'block' } : { display: 'none' }}
      >
        {props.options.map((item: Item) => {
          return (
            <li key={item.id} onClick={() => chooseItem(item)}>
              <i>{item.label}</i>
            </li>
          );
        })}
      </S.Menu>
    </S.SupportTypeOptionsWrapper>
  );
}

export { Dropdown as default };
